<template>
  <div>
    <input
			v-model="model.password" 
			type="password" 
			class="form-control"
			:placeholder="placeholder"
			:class="{ 'is-invalid': errors.has('password') }" 
		/>
    <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'confirmPassword',
  props: ['value', 'validate', 'placeholder'],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  methods: {},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
